// src/screens/admin/support/AdminTicketView.js

import React, { useEffect, useState,useContext } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminMasterLayout from '../../../../layouts/admin/AdminMasterLayout';
import AdminTicketHeader from '../../../../subscreens/admin/support/ticketHeader/AdminTicketHeader';
import AdminTicketInfo from '../../../../subscreens/admin/support/ticketInfo/AdminTicketInfo';
import AdminTicketChat from '../../../../subscreens/admin/support/ticketChat/AdminTicketChat';
import '../../../../assets/css/admin/subscreens/support/AdminTicketView.css';
import AppContext from '../../../../contexts/AppContext';

// Open hata diya, Rejected add kiya
const STATUS_OPTIONS = ['In Progress', 'Resolved', 'Rejected'];

const AdminTicketView = () => {
  const location = useLocation();
  const navigate = useNavigate();

 const { selectedConversation, baseUrl, adminAuthToken } = useContext(AppContext); 
 const conversation = selectedConversation;
const ticketFromState = conversation?.supporthelp;


  const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains('dark-mode'));
  const [ticketStatus, setTicketStatus] = useState(ticketFromState?.status || 'In Progress');
  const [savedStatus] = useState(ticketFromState?.status || 'In Progress');
  const [statusUpdating, setStatusUpdating] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    const observer = new MutationObserver(() =>
      setIsDarkMode(document.body.classList.contains('dark-mode'))
    );
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  if (!ticketFromState) {
    return (
      <AdminMasterLayout>
        <div style={{ padding: '2rem', textAlign: 'center', color: '#999' }}>
          Ticket not found.{' '}
          <button onClick={() => navigate('/admin/tickets')}
            style={{ color: '#fb7f4f', background: 'none', border: 'none', cursor: 'pointer' }}>
            Go back
          </button>
        </div>
      </AdminMasterLayout>
    );
  }

  const ticket = ticketFromState;

  const safeStr = (val) => {
    if (!val) return '—';
    if (typeof val === 'string') return val;
    if (typeof val === 'number') return String(val);
    if (typeof val === 'object') {
      return val.full_name || val.store_name || val.name ||
        (val.first_name ? `${val.first_name} ${val.last_name || ''}`.trim() : null) ||
        val.email || '—';
    }
    return String(val);
  };

  const safeEmail = (val) => {
    if (!val) return '—';
    if (typeof val === 'string') return val;
    if (typeof val === 'object') return val.email || val.business_email || '—';
    return String(val);
  };


  // Resolve customer name + email from ticket
const customerDisplay = conversation?.customer
  ? safeStr(conversation.customer)
  : conversation?.seller
    ? safeStr(conversation.seller)
    : '—';

const emailDisplay = conversation?.customer
  ? safeEmail(conversation.customer)
  : conversation?.seller
    ? safeEmail(conversation.seller)
    : '—';


  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleString('en-PK', {
      day: 'numeric', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  };

  const handleStatusUpdate = () => {
    if (ticketStatus === savedStatus) return;
    setStatusUpdating(true);

    const fd = new FormData();
    fd.append('ticket_id', ticket.id);
    fd.append('status', ticketStatus);

    axios.post(`${baseUrl}/admin/support/updateTicketStatus`, fd, {
      headers: { 'Content-Type': 'multipart/form-data',
        "Authorization": `Bearer ${adminAuthToken}`,
       },
    })
      .then(() => {
        toast.success(`Status updated to "${ticketStatus}"`);
        setStatusUpdating(false);
      })
      .catch(() => {
        toast.error('Failed to update status.');
        setStatusUpdating(false);
      });
  };

  // Button color — green for Resolved, red for Rejected
  const getBtnBg = () => {
    if (ticketStatus === 'Resolved') return '#16a34a';
    if (ticketStatus === 'Rejected') return '#dc2626';
    return '#fb7f4f';
  };

  const messages = Array.isArray(ticket.messages) ? ticket.messages : [];

  return (
    <AdminMasterLayout>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className={`admin-ticket-view-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <div className="admin-ticket-view-wrapper">
          <button className="atv-back-btn" onClick={() => navigate('/admin/tickets')}>
            <FiArrowLeft /> Back to Support
          </button>

          <AdminTicketHeader
            ticketId={`#TCK-${ticket.id}`}
            customer={customerDisplay}
            email={emailDisplay}
            subject={ticket.category || '—'} 
            status={ticketStatus}
            priority={ticket.priority || null}
          />

          <div className="atv-layout">
            <div className="atv-left">
              <div className="atv-status-card">
                <h3 className="atv-card-title atv-status-title">Status Management</h3>
                <p className="atv-status-label">CURRENT STATUS</p>
                <select
                  className="atv-status-select"
                  value={ticketStatus}
                  onChange={(e) => setTicketStatus(e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
                <button
                  className="atv-status-btn"
                  style={{ background: getBtnBg() }}
                  onClick={handleStatusUpdate}
                  disabled={statusUpdating || ticketStatus === savedStatus}
                >
                  {statusUpdating ? 'Updating...' : 'Update Status'}
                </button>
              </div>

              <AdminTicketInfo
                created={formatDate(ticket.created_at)}
                updated={formatDate(ticket.updated_at)}
                category={ticket.category || '—'}
                description={ticket.description || ticket.message || '—'}
              />
            </div>

            <div className="atv-right">
              <AdminTicketChat
                ticketId={ticket.id}
                messages={messages}
                status={ticketStatus}
                customerName={customerDisplay}
                 baseUrl={baseUrl}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminMasterLayout>
  );
};

export default AdminTicketView;